/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ old: NonNullable<unknown> }} Pm_Will_ReplaceInputs */

const cs_pm_will_replace = /** @type {(inputs: Pm_Will_ReplaceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nahradí současné ID ${i?.old}.`)
};

const en_pm_will_replace = /** @type {(inputs: Pm_Will_ReplaceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Replaces current ID ${i?.old}.`)
};

/**
* | output |
* | --- |
* | "Replaces current ID {old}." |
*
* @param {Pm_Will_ReplaceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_will_replace = /** @type {((inputs: Pm_Will_ReplaceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Will_ReplaceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_will_replace(inputs)
	return cs_pm_will_replace(inputs)
});